import { Observable } from 'rxjs';
import { Component, ChangeDetectionStrategy, ViewChild, ElementRef, HostBinding, OnDestroy, Input } from '@angular/core';
import { SafeResourceUrl } from '@angular/platform-browser';
import { HybridIframeManagerService, IFrameStyle } from '../../services/hybrid-iframe-manager.service';

@Component({
    selector: 'p-hybrid-iframe',
    templateUrl: './hybrid-iframe.component.html',
    styleUrls: ['./hybrid-iframe.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HybridIframeComponent implements OnDestroy {
    public readonly customStyles$: Observable<IFrameStyle | undefined>;
    public readonly sourceUrl$: Observable<SafeResourceUrl | null>;

    private bounds: DOMRect | null = null;
    private showOldApp: boolean = false;

    constructor(private readonly iframeManager: HybridIframeManagerService) {
        this.customStyles$ = iframeManager.customStyles$;
        this.sourceUrl$ = iframeManager.sourceUrl$;

        this.iframeManager.bounds$.subscribe((bounds) => (this.bounds = bounds));
        this.iframeManager.showOldApp$.subscribe((v) => {
            this.showOldApp = v;
        });
    }

    @ViewChild('iframe')
    private set iframe({ nativeElement }: ElementRef) {
        this.iframeManager.setIframe(nativeElement);
    }

    ngOnDestroy(): void {
        this.iframeManager.clearIframe();
    }

    @HostBinding('style.left.px') public get left(): string | number {
        return this.bounds?.left ?? 0;
    }
    @HostBinding('style.top.px') public get top(): string | number {
        return this.bounds?.top ?? 0;
    }
    @HostBinding('style.width') public get width(): string | number {
        return this.bounds ? `${this.bounds.width}px` : '100%';
    }
    @HostBinding('style.height') public get height(): string | number {
        return this.bounds ? `${this.bounds.height}px` : '100%';
    }

    @HostBinding('style.z-index') public get zIndex(): number | undefined {
        return this.bounds ? 99999 : undefined;
    }

    @HostBinding('style.visibility') public get visibility(): string | undefined {
        return this.showOldApp ? 'visible' : 'hidden';
    }
}
